<template>
  <div>
    <v-snackbar v-model="snackbar" bottom :timeout="tm">
      {{ text }}
      <v-btn
        v-if="createSlug || (event && event._id)"
        color="pink lighten-1"
        text
        @click="onClick"
      >{{$store.state.user.langEng ? 'Undo' : 'Ångra'}}</v-btn>
      <v-btn
        v-else
        color="pink lighten-1"
        text
        @click="onClick"
      >{{$store.state.user.langEng ? 'Close' : 'Stäng'}}</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbarRefresh" top :timeout="tm">
      {{ textRefresh }}
      <button color="primary" text @click="onClickRefresh">Refresh</button>
      <v-btn
        color="pink lighten-1"
        text
        @click="onClickRefreshClose"
      >{{$store.state.user.langEng ? 'Close' : 'Stäng'}}</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { deleteFetch } from "@/utils";

const minimumTimeDisplayed = 5000;

@Component
export default class Snackbar extends Vue {
  snackbar = false;
  snackbarRefresh = false;

  // Variadic, see "showSnackbar()"
  tm = minimumTimeDisplayed;

  @Watch("$store.state.snackbar.show")
  showSnackbar() {
    this.tm = Math.max(minimumTimeDisplayed, 1000 + this.text.length * 100);
    this.snackbar = true;
  }

  @Watch("$store.state.snackbar.showRefresh")
  showSnackbarRefresh() {
    this.snackbarRefresh = true;
  }

  onClick() {
    this.snackbar = false;
    if (this.event && this.event._id) {
      deleteFetch("/rest/CalendarEvent/" + this.event._id);
      this.$store.commit("calendar/removeEvent", this.event);
    } else if (this.createSlug) {
      history.replaceState({}, null, "/create-article/" + this.createSlug);
    }
  }

  onClickRefresh() {
    // location.reload();
    this.$router.go(-1);
    setTimeout(() => {
      this.$router.go(1);
    }, 0)
    this.onClickRefreshClose();
  }

  onClickRefreshClose() {
    this.snackbarRefresh = false;
  }

  get text() {
    return this.$store.state.snackbar.text;
  }

  get textRefresh() {
    return this.$store.state.snackbar.textRefresh;
  }

  get event() {
    return this.$store.state.snackbar.event;
  }

  get createSlug() {
    return this.$store.state.snackbar.createSlug;
  }
}
</script>
